"use strict";
/**
 * @module Services.FetchJMXValues
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var error_reason_serialiser_1 = require("../error-reason-serialiser");
var mbean_values_serialiser_1 = require("./mbean-values-serialiser");
/**
 * Serialiser for {@link JMXFetchResponse}
 */
var JMXFetchResponseSerialiserClass = /** @class */ (function (_super) {
    __extends(JMXFetchResponseSerialiserClass, _super);
    function JMXFetchResponseSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link JMXFetchResponse} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link JMXFetchResponse} that was read
     */
    JMXFetchResponseSerialiserClass.prototype.read = function (bis) {
        return Codec.readDictionary(bis, this.readWrapper);
    };
    /**
     * Write a {@link JMXFetchResponse} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link JMXFetchResponse} to be written
     */
    JMXFetchResponseSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeDictionary(bos, value, this.writeWrapper);
    };
    JMXFetchResponseSerialiserClass.prototype.readWrapper = function (bis) {
        switch (Codec.readByte(bis)) {
            case 0:
                return mbean_values_serialiser_1.MBeanValuesSerialiser.read(bis);
            default:
            case 1:
                return error_reason_serialiser_1.ErrorReasonSerialiser.read(bis);
        }
    };
    JMXFetchResponseSerialiserClass.prototype.writeWrapper = function (bos, value) {
        if (this.isErrorReason(value)) {
            Codec.writeByte(bos, 1);
            error_reason_serialiser_1.ErrorReasonSerialiser.write(bos, value);
        }
        else {
            Codec.writeByte(bos, 0);
            mbean_values_serialiser_1.MBeanValuesSerialiser.write(bos, value);
        }
    };
    JMXFetchResponseSerialiserClass.prototype.isErrorReason = function (input) {
        return 'reason' in input;
    };
    return JMXFetchResponseSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.JMXFetchResponseSerialiserClass = JMXFetchResponseSerialiserClass;
/**
 * The singleton
 */ // tslint:disable-next-line:variable-name
exports.JMXFetchResponseSerialiser = new JMXFetchResponseSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/fetch-jmx-values/jmx-fetch-response-serialiser.js
// module id = 1296
// module chunks = 1